import { EventsManager, FlowEvents } from "../../../abstracts/events/EventsManager";
import { UCNormalBetPresentation } from "../normal/UCNormalBetPresentation";

export class UCFreespinBetPresentation extends UCNormalBetPresentation {
    constructor(protected id: string = `UCFreespinBetPresentation`) {
        super(id);
    }

    protected override onBetStarted(): void {
        EventsManager.trigger(FlowEvents.BET_STARTED);

        const freespinsLeft = this.model.data.freespinsLeft;

        this.flowPresentationTimeline.call(
            () => {
                this.keypad.setZeroBetSpinCounter(freespinsLeft - 1);
            },
            undefined,
            0.4
        );
    }
}
